import React from "react";
import { FiChevronRight } from "react-icons/fi";
import { Skeleton, Widget } from "../../activity-logs/styles";
import { Bento, BentoTile, HeaderLink } from "../styles";
import { MoneyValue } from "./parts";
import { categoryMeta, formatCompact, formatCount, formatCurrency, formatPercent } from "../dashboardData";

function Tile({ row, size, onSelect }) {
  const Icon = row.meta.icon;
  const percent = formatPercent(row.share).replace("%", "");
  return (
    <BentoTile
      type="button"
      $color={row.meta.color}
      $size={size}
      title={`${row.meta.label}: ${formatCurrency(row.total)}`}
      onClick={() => onSelect(row.key)}
    >
      <span className="top">
        <span className="pct">{percent}<small>%</small></span>
        <span className="icon"><Icon /></span>
      </span>
      <span className="bottom">
        <span className="label">{row.meta.label}</span>
        <span className="amount">
          {size === "small" ? formatCompact(row.total) : <MoneyValue value={row.total} />}
        </span>
        <span className="track"><span className="level" style={{ width: `${row.share}%` }} /></span>
      </span>
    </BentoTile>
  );
}

/**
 * Mosaico de categorias: o tamanho do bloco segue o ranking, então a proporção se
 * percebe antes da leitura. A maior ocupa uma coluna, a segunda fica no alto à
 * direita e as demais dividem a base. A barra de cada bloco mostra a parte real.
 */
export default function CategoryBento({ categories, loading, delay, onSelect, onSeeAll }) {
  const sum = categories.reduce((acc, c) => acc + c.total, 0);
  const rows = categories.slice(0, 6).map((c) => ({
    ...c, meta: categoryMeta(c.key), share: sum > 0 ? (c.total / sum) * 100 : 0,
  }));
  const [first, second, ...rest] = rows;

  return (
    <Widget data-tour="categories" $span={2} $delay={delay} style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12 }}>
        <div style={{ minWidth: 0 }}>
          <div className="w-title">Por categoria</div>
          <div className="w-sub">
            {rows.length > 0
              ? `${formatCompact(sum)} em ${formatCount(rows.length)} ${rows.length === 1 ? "categoria" : "categorias"}`
              : "Sem dados no período"}
          </div>
        </div>
        <HeaderLink type="button" onClick={onSeeAll}>Ver todas <FiChevronRight /></HeaderLink>
      </div>

      {loading && <div style={{ marginTop: 14, flex: 1 }}><Skeleton $h={214} $r={12} /></div>}
      {!loading && first && (
        <Bento>
          <Tile row={first} size="large" onSelect={onSelect} />
          {second && (
            <div className="side">
              <Tile row={second} size="medium" onSelect={onSelect} />
              {rest.length > 0 && (
                <div className="base">
                  {rest.map((r) => <Tile key={r.key} row={r} size="small" onSelect={onSelect} />)}
                </div>
              )}
            </div>
          )}
        </Bento>
      )}
    </Widget>
  );
}
